<template>
  <div
    v-click-outside="onClose"
    v-if="isVisible" class="search-box animated fadeIn">
    <b-input-group>
      <b-dropdown :text="dropdownText" variant="success" slot="prepend">
        <b-dropdown-item @click="onChangeFindType('shipment_number')">Shipment Number</b-dropdown-item>
        <b-dropdown-item @click="onChangeFindType('order_number')">Order Number</b-dropdown-item>
        <b-dropdown-item @click="onChangeFindType('customer_name')">Customer Name</b-dropdown-item>
      </b-dropdown>
      <b-form-input
        class="text-search"
        @keydown.enter.native="onFindData"
        v-model="textSearch"
        ref="search-input"
        placeholder="Search ..."
        :style="inputBoxStyles"
      ></b-form-input>
      <b-input-group-append>
        <b-btn @click="onFindData" variant="primary">
          <i title="Start Search" class="fa fa-search search-box-icon"></i>
        </b-btn>
        <b-btn @click="showCalendar()" v-if="useDaterange" variant="primary">
          <span>{{ dateSearch }}</span>
          <i class="fa fa-calendar date-picker"></i>
        </b-btn>
      </b-input-group-append>
    </b-input-group>
    <flatpickr
      v-if="useDaterange"
      v-model="dateSearch"
      :config="config"
      ref="dRange-search-control"
      class="dRange-search-control"
      name="date">
    </flatpickr>
    <b-modal ref="search-validation-modal" class="search-validation-modal" hide-footer title="Search Information">
      <div class="d-block text-center">
        <h4>{{ alertMessage }}</h4>
      </div>
      <b-btn class="mt-3" variant="outline-danger" block @click="showHideModal(false)">Close Me</b-btn>
    </b-modal>
  </div>
</template>
<script>
import { trim, isEmpty } from 'lodash';
import Flatpickr from 'vue-flatpickr-component';
import ClickOutside from 'vue-click-outside';
import { format, subDays } from 'date-fns';

export default {
  name: 'search-box',
  components: {
    Flatpickr,
  },
  data() {
    return {
      onLoadingSearch: false,
      alertMessage: '',
      typeSearch: 'shipment_number',
      textSearch: '',
      dateSearch: null,
      useDaterange: false,
      dropdownText: 'By Shipment Number',
      inputBoxStyles: {
        width: '',
      },
      config: {
        altFormat: 'j F Y',
        altInput: true,
        mode: 'range',
      },
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    useDaterange(isUseDate) {
      if (!isUseDate) {
        this.dropdownText = 'By Shipment Number';
        this.typeSearch = 'shipment_number';
      }
    },
    isVisible(show) {
      if (show) {
        this.setWidthInputBox(this.typeSearch === 'customer_name');
      } else {
        this.onClose();
      }
    },
  },
  created() {
    this.setInitialWdth();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.setWidthInputBox(this.typeSearch === 'customer_name');
      });
    });
  },
  methods: {
    setInitialWdth() {
      this.inputBoxStyles.width = `${window.innerWidth - 600}px`;
    },
    setInitializeDate() {
      const startDate = format(subDays(new Date(), 1), 'YYYY-MM-DD');
      const endDate = format(subDays(new Date(), 7), 'YYYY-MM-DD');
      this.dateSearch = `${startDate} to ${endDate}`;
    },
    setWidthInputBox(withDaterange) {
      const windowWidth = window.innerWidth;
      const wd = withDaterange ? windowWidth - 770 : windowWidth - 600;
      this.inputBoxStyles.width = `${wd}px`;
    },
    onClose() {
      const fp = document.querySelector('.flatpickr-calendar');
      if (this.onLoadingSearch) {
        return false;
      }

      if (fp) {
        if (fp.classList.contains('open')) {
          return false;
        }
      }

      this.$emit('close-input', false);

      return true;
    },
    onChangeFindType(type) {
      this.typeSearch = type;
      this.setWidthInputBox(type === 'customer_name');

      switch (type) {
        case 'order_number':
          this.dropdownText = 'By Order Number';
          this.useDaterange = false;
          break;
        case 'customer_name':
          this.dropdownText = 'By Customer Name';
          this.useDaterange = true;
          this.setInitializeDate();
          break;
        default:
          this.dropdownText = 'By Shipment Number';
          this.useDaterange = false;
          break;
      }
    },
    showCalendar() {
      const dRangeElem = this.$refs['dRange-search-control'];
      dRangeElem.fp.open();
    },
    showHideModal(show) {
      if (show) {
        this.$refs['search-validation-modal'].show();
      } else {
        this.$refs['search-validation-modal'].hide();
      }
    },
    validate() {
      const dateSearchIsValid = !(this.dateSearch === null || this.dateSearch === '');
      let textSearchIsValid = false;
      let isValid = true;

      const textIsNotEmpty = this.textSearch !== '';
      const textMoreThan3Char = this.textSearch.toString().length >= 4;

      if (textIsNotEmpty) {
        if (textMoreThan3Char) {
          textSearchIsValid = true;
        } else {
          this.alertMessage = 'Enter at least 4 characters of text.';
        }
      } else {
        this.alertMessage = 'Fill text, please.';
      }

      if (this.typeSearch === 'customer_name') {
        this.alertMessage = 'Fill at least 4 characters of text or date range completely, please.';
        isValid = textSearchIsValid && dateSearchIsValid;
      } else {
        isValid = textSearchIsValid;
      }

      if (!isValid) {
        this.showHideModal(true);
      }

      return isValid;
    },
    onFindData() {
      if (!this.validate()) { return false; }

      const { textSearch, dateSearch, typeSearch } = this;
      const postData = {
        limit: 100,
        offset: 0,
      };
      let sDate = '';
      let eDate = '';

      if (typeSearch === 'customer_name') {
        const splitDate = dateSearch.split('to');
        sDate = `${trim(splitDate[0])} 00:00:00`;
        eDate = isEmpty(trim(splitDate[1])) ? `${trim(splitDate[0])} 23:59:59` : `${trim(splitDate[1])} 23:59:59`;

        if (isEmpty(splitDate[1])) {
          this.dateSearch = `${sDate} to ${eDate}`;
        }

        postData.customer_name = trim(textSearch);
        postData.start_date = sDate;
        postData.end_date = eDate;
      } else {
        postData[typeSearch] = trim(textSearch);
      }

      const tmpDropdownText = this.dropdownText;
      this.dropdownText = 'Loading ...';
      this.onLoadingSearch = true;
      this.$store.dispatch('shipment_md/shipments/FIND_SHIPMENTS_BY_RELATED_ORDER', postData)
        .then(({ rows }) => {
          if (isEmpty(rows)) {
            this.alertMessage = 'No result data.';
            this.showHideModal(true);
          } else {
            this.$router.push('/shipment_md/find_shipment_result');

            this.$router.push({ query: { ...this.$route.query, query: trim(textSearch) } });
            this.$router.push({ query: { ...this.$route.query, type: typeSearch } });
            this.$router.push({ query: { ...this.$route.query, page: 1 } });

            if (typeSearch === 'customer_name') {
              this.$router.push({ query: { ...this.$route.query, start_date: sDate } });
              this.$router.push({ query: { ...this.$route.query, end_date: eDate } });
            }
          }
          this.dropdownText = tmpDropdownText;
          this.onLoadingSearch = false;
        });

      return true;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
<style lang="sass">
  @import "~flatpickr/dist/flatpickr.min"
  @import "~vue-multiselect/dist/vue-multiselect.min"

  .search-box-icon
    cursor: pointer;

  .search-box
    position: absolute;
    top: 60px;
    right: 70px;
    padding: 10px;
    z-index: 9999!important;
    background-color: #e6e6e6bf;
    color: #fff;
    border-radius: 3px;
    border: 1px solid #c2cfd6;

  .search-box input.text-search
    height: calc(1.5em + 0.75rem + 6px);

  .search-input
    border: 0px;
    color: #fff;
    background-color: #29363d;
    height: 35px;
    padding-left: 10px;

  .close-search-input
    margin: 8px;
    cursor: pointer;

  .dRange-search-control
    width: 0px;
    height: 0px;
    display: inline-block;
    background-color: #29363d !important;
    border: 0px;
    position: absolute;
    right: 15px;
    top: 30px;

  .date-text
    display: inline-block;
    width: 170px;

  .search-validation-modal
    color: black;
</style>



// WEBPACK FOOTER //
// src/components/SearchBox.vue